import { PropsWithChildren } from 'react';
import { createContext, useContextSelector } from 'use-context-selector';

import { EventTypeDto } from '@pimm/services/lib/threshold-profiles';

type EquipmentConfigContextReturn = {
  eventTypes: EventTypeDto[];
  canEditSensor: boolean;
  canDataSync: boolean;
};

type EquipmentConfigProviderProps = PropsWithChildren & Partial<EquipmentConfigContextReturn>;

const EquipmentConfigContext = createContext<EquipmentConfigContextReturn>({
  eventTypes: [],
  canEditSensor: false,
  canDataSync: false,
});

export const EquipmentConfigProvider = ({
  children,
  eventTypes = [],
  canEditSensor = false,
  canDataSync = false,
}: EquipmentConfigProviderProps) => (
  <EquipmentConfigContext.Provider value={{ eventTypes, canEditSensor, canDataSync }}>{children}</EquipmentConfigContext.Provider>
);

export const useEquipmentConfig = <T,>(selector: (ctx: EquipmentConfigContextReturn) => T): T =>
  useContextSelector(EquipmentConfigContext, selector);
